enum CURRENCY {
  USD = '$',
  GBP = '£',
}

export default CURRENCY;
